export const BUSINESS = {
  name: "Panificio Caffetteria Laboratorio di Laurie",
  short: "di Laurie",
  category: "Pasticceria · Panificio · Caffetteria artigianale",
  phone: "347 709 9496",
  phoneHref: "tel:+393477099496",
  address: "Via Don Giovanni Zanardo, 26",
  city: "31040 Chiarano (TV)",
  mapsDir:
    "https://www.google.com/maps/dir/?api=1&destination=Via+Don+Giovanni+Zanardo+26+Chiarano+TV",
  rating: "4,6",
  reviewsCount: "199",
  instagram: "https://www.instagram.com/laboratorio_di_laurie/",
  facebook: "https://www.facebook.com/p/Laboratorio-di-Laurie-panificio-artigianale-caffetteria-e-pasticceria-100063763050465/?locale=it_IT",
  logo: "/logo-laurie.png?v=2",
  reviewsUrl:
    "https://www.google.com/maps/search/?api=1&query=Panificio%20Caffetteria%20Laboratorio%20di%20Laurie%2C%20Via%20Don%20Giovanni%20Zanardo%2C%2026%2C%2031040%20Chiarano%20TV",
};

const A = "https://customer-assets-0z36b82j.emergentagent.net/job_laboratorio-laurie/artifacts";

export const IMAGES = {
  // Foto reali del laboratorio di Laurie
  heroVideo: `${A}/anhi9y6n_WhatsApp%20Video%202026-08-05%20at%2020.48.47.mp4`, // fornaio al lavoro (cinematic)
  heroPoster: `${A}/dactq6tk_IMG_9657.jpeg`, // frame del video
  heroImage: `${A}/x7vmyxq2_IMG_9658.jpeg`, // fornaio che versa la crema
  hero: `${A}/b4auznk2_IMG_9649.jpeg`, // pan brioche con panna e fragole
  baker: `${A}/td5ocws0_IMG_9652.jpeg`, // biscotti decorati farfalle/fiori (creativita')
  croissant: `${A}/je2swq7a_IMG_9648.jpeg`, // sfogliata con canditi
  macarons: `${A}/d2henmjm_IMG_9650.jpeg`, // crostata di fragole
  pastries: `${A}/ocvhzkbx_IMG_9651.jpeg`, // biscotti decorati personalizzati
  latte: `${A}/cja2230v_IMG_9659.jpeg`, // cappuccino latte art con croissant
  // Salateria
  salaPizza: `${A}/g7znjrm0_IMG_9654.jpeg`, // pizza al carbone a spicchi
  salaFocaccia: `${A}/ti5updg8_IMG_9663.jpeg`, // focaccia zucchine
  salaCornettiNeri: `${A}/hjrwnr18_IMG_9655.jpeg`, // cornetti salati al carbone
  salaCornettiIntegrali: `${A}/6uhjrr0e_IMG_9656.jpeg`, // cornetti integrali con crudo
  salaPizzette: `${A}/n9m4ps1t_IMG_9662.jpeg`, // pizzette rosse al carbone
  // Foto neutra (nessuna foto reale fornita per il pane)
  breadRack:
    "https://customer-assets-0z36b82j.emergentagent.net/job_laboratorio-laurie/artifacts/3fi6fcvz_WhatsApp%20Image%202026-08-22%20at%2010.14.49.webp",
};

export const MENU = [
  {
    key: "colazione",
    title: "Colazione",
    tag: "Ogni mattina",
    desc: "Brioche calde, croissant e cappuccino.",
    image: IMAGES.croissant,
    items: [
      "Croissant e brioche appena sfornati",
      "Strudel, crostatine e sfogliette crema e mele",
      "Caffè BIO origine Perù e cappuccino",
    ],
  },
  {
    key: "pasticceria",
    title: "Pasticceria",
    tag: "Le nostre firme",
    desc: "Torte, biscotti, macarons e creazioni originali fatte a mano ogni giorno.",
    image: IMAGES.macarons,
    items: [
      "Torte e biscotti",
      "Macarons in più gusti",
      "Pasticceria mignon e da tè",
      "Idee originali e stagionali",
    ],
  },
  {
    key: "salateria",
    title: "Salateria",
    tag: "Non solo dolce",
    desc: "Pizza al taglio, focacce e cornetti salati, anche con il nostro impasto al carbone vegetale.",
    image: IMAGES.salaPizza,
    items: [
      "Pizza al taglio — anche al carbone",
      "Focacce farcite (zucchine, formaggi…)",
      "Cornetti salati e integrali con salumi",
      "Pizzette rosse per la pausa pranzo",
    ],
  },
  {
    key: "pane",
    title: "Pane",
    tag: "Forno proprio",
    desc: "Pane artigianale a lunga lievitazione, impastato, formato e cotto nel nostro laboratorio.",
    image: IMAGES.breadRack,
    items: [
      "Pane fresco tutti i giorni",
      "Lievitazione naturale",
      "Focacce e prodotti da forno",
    ],
  },
  {
    key: "caffetteria",
    title: "Caffetteria",
    tag: "Sul posto o d'asporto",
    desc: "Un angolo caldo dove fermarsi, dal caffè del mattino alla pausa dolce.",
    image: IMAGES.latte,
    items: [
      "Caffè, cappuccino, orzo",
      "Consumazione sul posto",
      "Servizio d'asporto",
    ],
  },
];

export const REVIEWS = [
  {
    name: "Giulia M.",
    text: "Prodotti freschi e genuini, si sente la qualità degli ingredienti. Il dolce al cocco è una piccola meraviglia.",
    note: "Dolce al cocco",
  },
  {
    name: "Marco R.",
    text: "Personale gentilissimo e professionale. Il latte macchiato con tiramisù è diventato la mia colazione fissa.",
    note: "Colazione",
  },
  {
    name: "Elena T.",
    text: "Prodotti sempre freschi e curati, con idee originali e creative. Ogni volta scopro qualcosa di nuovo e buonissimo.",
    note: "Creatività",
  },
  {
    name: "Davide P.",
    text: "I macarons sono spettacolari e curati nei dettagli. Un panificio artigianale come si faceva una volta.",
    note: "Macarons",
  },
];

export const HOURS = [
  { day: "Lunedì", short: "Lun", slots: [] },
  { day: "Martedì", short: "Mar", slots: [["06:00", "12:30"], ["15:30", "19:00"]] },
  { day: "Mercoledì", short: "Mer", slots: [["06:00", "12:30"], ["15:30", "19:00"]], busy: true },
  { day: "Giovedì", short: "Gio", slots: [["06:00", "12:30"], ["15:30", "19:00"]] },
  { day: "Venerdì", short: "Ven", slots: [["06:00", "12:30"], ["15:30", "19:00"]] },
  { day: "Sabato", short: "Sab", slots: [["06:00", "12:30"], ["15:30", "19:00"]] },
  { day: "Domenica", short: "Dom", slots: [["07:00", "12:30"]] },
];

export const fmtTime = (t) => (t.endsWith(":00") ? t.slice(0, 2) : t);

export const dayHours = (h) =>
  h.slots.length
    ? h.slots.map(([o, c]) => `${fmtTime(o)}–${fmtTime(c)}`).join(" · ")
    : "Chiuso";
